import { useEffect } from "react";
import { AccountFranchiseAuditLogDisplay } from "./Display";

export const AccountFranchiseAuditLogPage = () => {
  useEffect(() => {
    document.title = "Account Audit History";
  }, []);

  return <AccountFranchiseAuditLogDisplay />;
};
